import { type FC } from 'react'
import { observer } from 'mobx-react-lite'
import { IconButton } from 'shared/ui'
import { ZIndex } from 'shared/constants/zIndex'
import { type CallContact } from 'entities/Call/model/CallContact'

type IRemoveActionProps = {
  item: CallContact
  onRemove: (item: CallContact) => void
  innerRefCurrent?: HTMLDivElement
}

export const RemoveAction: FC<IRemoveActionProps> = observer(
  ({ item, onRemove, innerRefCurrent }) => (
    <IconButton
      ariaLabel={'Remove'}
      icon={'phoneHangUp'}
      size={'small'}
      color={'tertiary'}
      variant={'icon'}
      tooltipProps={{
        label: 'Remove from call',
        placement: 'top',
        zIndex: ZIndex.OVERLAY_TOP_1,
        PopperProps: {
          popperOptions: {
            modifiers: [{ name: 'preventOverflow', options: { boundary: innerRefCurrent } }],
          },
        },
      }}
      onClick={() => onRemove(item)}
    />
  )
)
